var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.75C0.25 7.30228 0.697715 7.75 1.25 7.75H5.25C5.80228 7.75 6.25 7.30228 6.25 6.75V1.25C6.25 0.697715 5.80228 0.25 5.25 0.25H1.25C0.697715 0.25 0.25 0.697715 0.25 1.25V6.75ZM0.25 12.75C0.25 13.3023 0.697715 13.75 1.25 13.75H5.25C5.80228 13.75 6.25 13.3023 6.25 12.75V10.25C6.25 9.69771 5.80228 9.25 5.25 9.25H1.25C0.697715 9.25 0.25 9.69771 0.25 10.25V12.75ZM7.75 12.75C7.75 13.3023 8.19772 13.75 8.75 13.75H12.75C13.3023 13.75 13.75 13.3023 13.75 12.75V7.25C13.75 6.69772 13.3023 6.25 12.75 6.25H8.75C8.19772 6.25 7.75 6.69772 7.75 7.25V12.75ZM8.75 0.25C8.19772 0.25 7.75 0.697715 7.75 1.25V3.75C7.75 4.30228 8.19772 4.75 8.75 4.75H12.75C13.3023 4.75 13.75 4.30228 13.75 3.75V1.25C13.75 0.697715 13.3023 0.25 12.75 0.25H8.75Z",
    fill: "#85B440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a4eeb3f2c858a2552ac8f11c1cf6cc26.svg";
export { ForwardRef as ReactComponent };